<template>
    <div class="h-full flex flex-col p-4">
        <bookkeeping-account-editor-drawer ref="editor"/>
        <import-saft-component />
        <bookkeeping-account-list
            :accounts="bookkeepingAccounts"
            :show-editor="showEditor"
        />
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import BookkeepingAccountList from '@/bookkeeping-account/BookkeepingAccountList.vue'
import BookkeepingAccountEditorDrawer from '@/bookkeeping-account/BookkeepingAccountEditorDrawer.vue'

import ImportSaftComponent from '@/components/ImportSaftComponent.vue'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'

const editor = ref(null)

const showEditor = (account: BookkeepingAccount) => {
    (editor.value as any)?.show(account)
}

</script>

<style>

</style>
